// Spotlight.jsx
import React, { useState, useEffect } from 'react';
import Spotlight from '../assets/img/about/light.png';

const SpotlightComponent = ({ offset = -50, size = 150 }) => {
  const [rotation, setRotation] = useState(0);

  const handleMouseMove = (e) => {
    const container = document.querySelector('.spotlight-container');
    if (!container) return;
    const rect = container.getBoundingClientRect();
    const centerX = rect.width / 2;
    const centerY = offset;
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    const angleRad = Math.atan2(mouseY - centerY, mouseX - centerX);
    const angleDeg = angleRad * (180 / Math.PI);
    const computedRotation = angleDeg + 270;
    // Clamp rotation so it stays between 180° and 360°
    const clampedRotation = Math.max(270, Math.min(450, computedRotation));
    setRotation(clampedRotation);
  };

  useEffect(() => {
    const isTouch = window.matchMedia('(max-width: 768px)').matches;
    if (isTouch) return;
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [offset]);

  return (
    <div className="spotlight-container absolute top-0 left-0 w-full h-full">
      <img
        src={Spotlight}
        alt="Spotlight"
        style={{
          position: 'absolute',
          top: offset,
          left: '50%',
          transform: `translateX(-50%) rotate(${rotation}deg)`,
          transformOrigin: '50% 0%',
          width: `${size}px`,
          pointerEvents: 'none',
        }}
        className="drop-shadow-[0_18px_12px_rgba(249,249,141,0.7)]"
      />
    </div>
  );
};

export default SpotlightComponent;
